
import { useHistory } from "react-router";


import React, {useState ,useEffect } from 'react';
import Toast from "../Common/Toast";
import NavBar from "../Common/NavBar";
import TopMenu from "../Common/TopMenu";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSave, faTimesCircle} from "@fortawesome/free-solid-svg-icons";
import API from "../../services/API";
import {toast} from "react-toastify";
import NeshanMap from 'react-neshan-map-leaflet'



function AddAddress() {
    const [map, setMap] = useState(null)
    const [input,setInput] = useState({
        title : '',
        city_id : 0,
        address :   '',
        postal_code : '',
        contact_name : '',
        province_id : 0,
        contact_number : '',
        has_traffic_plan : 0,
        is_personal_address : 0
        })
    const [provinces , setProvinces] = useState([]);
    const [L , setL] = useState(null);
    const [marker , setMarker] = useState(null);
    const [cities , setCities] = useState([]);
    const [publicAddresses , setPublicAddresses] = useState([]);
    const [cityName,setCityName] = useState('');
    const [provinceName,setProvinceName] = useState('');
    const [position, setPosition] = useState(map?map.getCenter() : {lat:36.434 , lng: 59.421})


 /*   const onMove = useCallback(() => {
        setPosition(map.getCenter())
    }, [map])*/
    const history = useHistory();
    useEffect(() => {
        if(provinces.length < 1) {
            API.provinces(83)
                .then((response) => {
                    setProvinces(response.results.provinces)
                })
            API.getPublicAddresses()
                .then((response) => {
                    const addresses = response.results.addresses;
                    setPublicAddresses(addresses)

                })
                .catch((error) => {
                    toast.error(error.response.data.user_message);
                });
        }
/*        if(map)
            map.on('move', onMove)
        return () => {
            if(map)
                map.off('move', onMove)
        }*/
    }, [/*map, onMove ,*/ input, provinces.length])
    const onButtonClick = ( ) => {
        if(!input.title || !input.city_id || !input.contact_name  ||  !input.contact_number) {
            toast.error('لطفا تمامی اطلاعات را کامل کنید');
            return false;
        }
        const request ={
            title : input.title,
            city_id : input.city_id ? input.city_id:input.cities[0].id,
            contact_name : input.contact_name,
            contact_number : input.contact_number,
            postal_code : input.postal_code,
            address : input.address,
            has_traffic_plan : input.has_traffic_plan,
            is_personal_address : input.is_personal_address,
            lat : position.lat,
            lng : position.lng,
        }
        API.saveAddress(request)
            .then((response) => {
                toast.success(response.user_message);
                setTimeout (() => {
                    const returnUrl = window.localStorage.getItem("return_to");
                    if(returnUrl === 'request') {
                        const a_type = window.localStorage.getItem("a_type");
                        if(a_type === '73') {
                            let loading_addresses = window.localStorage.getItem("loading_addresses");
                            if(loading_addresses) {
                                loading_addresses += ',' + response.results.address.id;
                            }
                            else {
                                loading_addresses =  response.results.address.id;
                            }
                            window.localStorage.setItem("loading_addresses", loading_addresses);
                        }
                        if(a_type === '72') {
                            let unloading_addresses = window.localStorage.getItem("unloading_addresses");
                            if(unloading_addresses) {
                                unloading_addresses += ',' + response.results.address.id;
                            }
                            else {
                                unloading_addresses =  response.results.address.id;
                            }

                            window.localStorage.setItem("unloading_addresses", unloading_addresses);
                        }
                        history.push('/request/new');
                    }
                    else {
                        history.push('/profile/addresses');
                    }

                },1500)
            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });
    }
    const onCityChange = (event)  =>{

        const inputName = event.target.name;
        let inputValue = event.target.value;
        setInput({ ...input , [inputName]: inputValue});
        var index = event.nativeEvent.target.selectedIndex;
        setCityName(event.nativeEvent.target[index].text);
        API.searchNeshan(event.nativeEvent.target[index].text)
            .then((response) => {
                if(response.items) {
                    const x = response.items[0].location.x;
                    const y = response.items[0].location.y;
                  //  setPosition({lat: y, lng: x})
                    map.panTo(new L.LatLng(y, x));
                }
            })
            .catch((error) => {
                console.log(error)
                //toast.error(error.response.data.user_message);
            });
    }
    const onInputChange = (event) => {
        const inputName = event.target.name;
        let inputValue = event.target.value;
        if(inputName === 'has_traffic_plan') {
            inputValue = 1 - input.has_traffic_plan;
        }
        if(inputName === 'is_personal_address') {
            inputValue = 1 - input.is_personal_address;
        }

        setInput({ ...input , [inputName]: inputValue});
        if(inputName === 'address' && inputValue.substr(inputValue.length - 1) === ' ') {
            const search = provinceName + ' ' +  cityName + ' ' + inputValue;
            API.searchNeshan(search)
                .then((response) => {
                    if(response.items) {
                        const x = response.items[0].location.x;
                        const y = response.items[0].location.y;
                       // setPosition({lat: y, lng: x})

                        map.panTo(new L.LatLng(y, x));
                    }
                })
                .catch((error) => {

                });
        }

    }
    const onProvinceChange = (event) => {
        const province_id = event.target.value;
        setInput({ ...input , province_id : province_id});
        var index = event.nativeEvent.target.selectedIndex;
        setProvinceName(event.nativeEvent.target[index].text);
        API.cities(province_id)
            .then((response) => {
                setCities(response.results.cities)
            })
    }
    const a_type = window.localStorage.getItem("a_type");
    const cancelAddress = () => {
        window.localStorage.removeItem("a_type");
        history.push('/request/new');
    }
    const onPublicAddressesChange = (event) => {
        const address_id = parseInt(event.target.value);

        const find_item = publicAddresses.find(x => x.id === address_id);
        API.cities(find_item.city.province.id)
            .then((response) => {
                setCities(response.results.cities)


                setInput({ ...input ,
                    title: find_item.title,
                    province_id: find_item.city.province.id,
                    city_id: find_item.city.id,
                    address: find_item.address,

                });
/*                setPosition({
                    lat: find_item.lat,
                    lng: find_item.lng,
                })*/
                map.panTo(new L.LatLng(find_item.lat, find_item.lng));
                marker.setLatLng(new L.LatLng(find_item.lat, find_item.lng))
                setPosition(new L.LatLng(find_item.lat, find_item.lng))
            })


    }

    return (
        <React.Fragment>

            <Toast/>
            <section className="container-fluid rtl ">
                <div className="row">
                    <div className="col-md-3 px-2">
                        <NavBar/>
                    </div>
                    <div className="col-md-9">
                        <TopMenu/>



                        <div className="text-center my-5 text-secondary">
                            <h2>
                                <strong>افزودن آدرس جدید</strong>

                            </h2>


                        </div>
                        <section className="container rtl  p-3 usual-content ">
                            <div className="row  p-2 rounded">
                                <div className="col-12 form-floating ">
                                    <select className='form-select bg-blue text-white' onChange={onPublicAddressesChange}>
                                        <option value="0">
                                            انتخاب آدرس
                                        </option>
                                        {
                                            publicAddresses.map(address => {
                                                return (
                                                    <option value={address.id}>{address.title}</option>
                                                )
                                            })
                                        }
                                    </select>
                                    <label htmlFor="province_id" className="super-small text-white">  استفاده از لیست آدرس های منتخب</label>
                                </div>
                            </div>
                            <div className="row">

                                <div className="form-floating col-md-4 mt-4">
                                    <input type="text"
                                           className="form-control px-5"
                                           id="title" name="title"
                                           placeholder="عنوان آدرس"
                                           value={input.title}
                                           onChange={onInputChange}/>
                                    <label htmlFor="title" className="super-small">عنوان آدرس</label>
                                </div>
                                <div className="form-floating col-md-4 mt-4">
                                    <select className="form-select" id="province_id" name="province_id"
                                            aria-label="Floating label select example"
                                            value={input.province_id}
                                            onChange={onProvinceChange}>
                                        <option value={0} >
                                            انتخاب استان
                                        </option>
                                        {provinces.map(pr => {
                                            return (
                                                <option value={pr.id} key={pr.id}>
                                                    {pr.title}
                                                </option>
                                            )
                                        })}
                                    </select>
                                    <label htmlFor="province_id" className="super-small">استان</label>
                                </div>
                                <div className="form-floating col-md-4 mt-4">
                                    <select className="form-select" id="city_id" name="city_id"
                                            aria-label="Floating label select example"
                                            value={input.city_id}
                                            onChange={onCityChange}
                                    >
                                        <option value={0} >
                                            انتخاب شهر
                                        </option>
                                        {cities.map(ct => {
                                            return (
                                                <option value={ct.id} key={ct.id}>
                                                    {ct.title}
                                                </option>
                                            )
                                        })}
                                    </select>
                                    <label htmlFor="city_id" className="super-small">شهر</label>
                                </div>
                                <div className="form-floating col-md-4 mt-4">
                                    <input type="text"
                                           className="form-control px-5"
                                           id="contact_name" name="contact_name"
                                           placeholder=" نام مسئول هماهنگی"

                                           onChange={onInputChange}/>
                                    <label htmlFor="contact_name" className="super-small">نام مسئول هماهنگی</label>
                                </div>
                                <div className="form-floating col-md-4 mt-4">
                                    <input type="tel"
                                           className="form-control px-5"
                                           id="contact_number" name="contact_number"
                                           placeholder=" شماره تماس مسئول هماهنگی"

                                           onChange={onInputChange}/>
                                    <label htmlFor="contact_number" className="super-small">شماره تماس مسئول هماهنگی</label>
                                </div>
                                <div className="form-floating col-md-4 mt-4">
                                    <input type="tel"
                                           className="form-control px-5"
                                           id="postal_code" name="postal_code"
                                           placeholder=" کد پستی"

                                           onChange={onInputChange}/>
                                    <label htmlFor="postal_code" className="super-small"> کد پستی</label>
                                </div>
                                <div className="form-floating col-md-8 mt-4">
                                    <textarea
                                           className="form-control px-5"
                                           id="address" name="address"
                                           placeholder=" آدرس"
                                           value={input.address}
                                           onChange={onInputChange}/>
                                    <label htmlFor="address" className="super-small"> آدرس دقیق</label>
                                </div>

                                <div className="custom-control custom-checkbox col-md-4 mt-4">

                                    <input type="checkbox"
                                           className="custom-control-input" id="has_traffic_plan" name="has_traffic_plan"
                                           placeholder="در محدوده طرح ترافیک"
                                           value = "1"
                                           onChange={onInputChange}/>


                                    &nbsp;
                                    <label htmlFor="has_traffic_plan"  className="custom-control-label "> آدرس در محدوده طرح ترافیک است</label>
                                </div>

                                <div className=" col-md-12 mt-2">
                                    <select className='btn super-small-2 btn-secondary change-map-type'
                                          onClick={(val) => {map.setMapType(val.target.value);}}

                                    >

                                        <option value='neshan'>
                                            تغییر نوع نقشه
                                        </option>
                                        <option value='dreamy'>
                                            dreamy
                                        </option>
                                        <option value='dreamy-gold'>
                                            dreamy-gold
                                        </option>
                                        <option value='standard-day'>
                                            standard-day
                                        </option>
                                        <option value='standard-night'>
                                            standard-night
                                        </option>

                                    </select>
                        {/*            <MapContainer
                                        center={center}
                                        zoom={zoom}
                                        scrollWheelZoom={false}
                                        whenCreated={setMap}
                                        className="driver-map px-2 rounded-more"

                                    >
                                        {
                                            mapType === 0 &&
                                            <TileLayer
                                                attribution='&copy; <a href="https://barsepar.com">سامانه بارسپار</a> '
                                                url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                                            />
                                        }
                                        {
                                            mapType === 1 &&
                                            <TileLayer
                                                attribution='&copy; <a href="https://barsepar.com">سامانه بارسپار</a> '
                                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                            />
                                        }

                                        <Marker
                                            position={[position.lat.toFixed(4),position.lng.toFixed(4)]}
                                            icon ={UserIcon}
                                        />
                                    </MapContainer>*/}


                                    <NeshanMap
                                        options={{
                                            key: 'web.1b9521ecbf8f47fe8c1866812d07a969',
                                            maptype: 'neshan' ,
                                            poi: true,
                                            traffic: true,
                                            center: [position.lat.toFixed(4),position.lng.toFixed(4)],
                                            zoom: 13,

                                        }}
                                        style = {{
                                    width : '100% !important'
                                    }
                                        }
                                        onInit={(L, myMap ) => {
                                            setMap(myMap)
                                            setL(L)
                                             let marker = L.marker([position.lat.toFixed(4),position.lng.toFixed(4)])
                                                .addTo(myMap)
                                                .bindPopup('موقعیت انتخاب شده');
                                            setMarker(marker)
                                            myMap.on('click', function (e) {
                                                setPosition(e.latlng)
                                               marker.setLatLng(e.latlng)
                                            });
                                        }}
                                    />
                                </div>
                                {a_type > 1 ?
                                  <div className="col-md-6 mt-4">

                                      <button className="btn btn-danger w-50"  onClick={cancelAddress}>
                                          <FontAwesomeIcon icon={faTimesCircle}/>
                                          &nbsp;
                                         انصراف از ثبت آدرس
                                      </button>
                                  </div>
                                   :<div className="custom-control custom-checkbox col-md-6 mt-4">

                                        <input type="checkbox"
                                               className="custom-control-input" id="is_personal_address" name="is_personal_address"
                                               placeholder=""
                                               value="1"
                                               onChange={onInputChange}/>
                                        &nbsp;
                                        <label htmlFor="is_personal_address"  className="custom-control-label ">آدرس به صورت شخصی ثبت شود؟</label>
                                        <p className="super-small-2 text-secondary rtl text-justify">
                                            آدرس های ثبت شده به صورت شخصی فقط برای شما ثبت می شود و توسط دیگر همکارانتان در  شرکت قابل مشاهده و استفاده نمی باشد
                                        </p>
                                    </div>
                                }

                                <div className="col-md-6 text-left mt-4">
                                    <button className="btn btn-success w-75 "  onClick={onButtonClick}>
                                        <FontAwesomeIcon icon={faSave}/>
                                        &nbsp;
                                        ثبت اطلاعات
                                    </button>
                                </div>
                            </div>
                        </section>
                    </div>

                </div>

            </section>

        </React.Fragment>


    )
}

export default AddAddress;
